import { render, staticRenderFns } from "./SelecionarRelatorio.vue?vue&type=template&id=2d9c48c2&scoped=true"
import script from "./SelecionarRelatorio.vue?vue&type=script&lang=js"
export * from "./SelecionarRelatorio.vue?vue&type=script&lang=js"
import style0 from "./SelecionarRelatorio.vue?vue&type=style&index=0&id=2d9c48c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c48c2",
  null
  
)

export default component.exports